import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import { isMobile } from "react-device-detect";
import clsx from "clsx";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
    fontFamily: "AP !important",
  },
  content: {
    margin: "0 auto",
    boxSizing: "border-box",
    maxWidth: 1195,
    // border: /\/complete/g.test(window.location.pathname)
    //   ? "none"
    //   : "1px solid #EFEFEF",
    [theme.breakpoints.down("xs")]: {
      paddingTop: 16,
      paddingBottom: 50,
      // padding: "30px 15px",
    },
    [theme.breakpoints.up("md")]: {
      // padding: 16,
      paddingBottom: 50,
    },
  },
  contentQuiz: {
    margin: "0 auto",
    marginTop: 30,
    boxSizing: "border-box",
    maxWidth: 1230,
    [theme.breakpoints.down("xs")]: {
      // paddingTop: 16,
      marginTop: -24,
      paddingBottom: 50,
      // padding: "30px 15px",
    },
    [theme.breakpoints.up("md")]: {
      // padding: 16,
      paddingTop: 112,
      paddingBottom: 50,
    },
    [theme.breakpoints.up("lg")]: {
      marginTop: -64,
    },
  },
  footer: {
    fontSize: 14,
    marginTop: 64,
    marginBottom: 64,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: "#000000",
    fontWeight: 500,
    [theme.breakpoints.down("xs")]: {
      marginTop: 16,
      marginBottom: 8,
    },
  },
  footerQuiz: {
    [theme.breakpoints.down("xs")]: {
      marginBottom: 100,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
  },
}));

const Layout = ({ children, style = {} }) => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Grid
        container
        direction="row"
        justifyContent="center"
        alignItems="center"
      >
        <Grid item xs={12}>
          <div style={style} className={classes.content}>
            {children}
          </div>
        </Grid>

        <Grid item xs={12} className={classes.footer}>
          Powered by&nbsp;
          <img src="/logo/logo.png" alt="ap" width="28.34" />
        </Grid>
      </Grid>
    </div>
  );
};

export default Layout;

export const LayoutQuiz = ({ children, style = {} }) => {
  const classes = useStyles();
  return (
    <div className={classes.root} style={style}>
      <Grid
        container
        direction="row"
        justifyContent="center"
        alignItems="center"
      >
        <Grid item xs={12}>
          <div className={classes.contentQuiz}>{children}</div>
        </Grid>

        <Grid item xs={12} className={clsx(classes.footer, classes.footerQuiz)}>
          Powered by&nbsp;
          <img src="/logo/logo.png" alt="ap" width="28.34" />
        </Grid>
      </Grid>
    </div>
  );
};
